var _path, _path2, _path3, _path4, _path5, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0406 15.8008L18.0762 15.8008C16.8195 15.8008 15.8008 16.8195 15.8008 18.0762L15.8008 25.7556L15.8008 35.7103L15.8008 45.6651V49.7246C15.8008 50.9813 16.8195 52 18.0762 52H23.0406H33.9004L44.7601 52H49.7246C50.9813 52 52 50.9812 52 49.7246V45.6651L52 35.7103V25.7556V18.0762C52 16.8195 50.9813 15.8008 49.7246 15.8008H44.7601L33.9004 15.8008L23.0406 15.8008Z",
    stroke: "#7647EE",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 1C29.0294 1 25 4.58172 25 9L43 9C43 4.58172 38.9706 1 34 1Z",
    fill: "#F3F1FC",
    stroke: "#7647EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 67C29.0294 67 25 63.4183 25 59H43C43 63.4183 38.9706 67 34 67Z",
    fill: "#F3F1FC",
    stroke: "#7647EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67 34C67 38.9706 63.4183 43 59 43L59 25C63.4183 25 67 29.0294 67 34Z",
    fill: "#F3F1FC",
    stroke: "#7647EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 34C1 38.9706 4.58172 43 9 43L9 25C4.58172 25 1 29.0294 1 34Z",
    fill: "#F3F1FC",
    stroke: "#7647EE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2207_40832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7512 24.4272C25.7512 24.2914 25.6973 24.1611 25.6013 24.0651C25.4013 23.8652 25.0772 23.8652 24.8772 24.0651C24.7812 24.1611 24.7273 24.2914 24.7273 24.4272V29.3347H23.7034V24.3904C23.7034 24.2781 23.6588 24.1705 23.5794 24.0912C23.3651 23.8769 23.0177 23.8769 22.8034 24.0912C22.724 24.1705 22.6794 24.2781 22.6794 24.3904V30.5862C22.6794 31.5915 23.4944 32.4065 24.4998 32.4065C24.6254 32.4065 24.7273 32.5084 24.7273 32.634V43.4787C24.7273 43.601 24.7759 43.7183 24.8623 43.8047C25.0705 44.0129 25.408 44.0129 25.6162 43.8047C25.7027 43.7183 25.7512 43.601 25.7512 43.4787V32.634C25.7512 32.5084 25.8531 32.4065 25.9788 32.4065C26.9841 32.4065 27.7991 31.5915 27.7991 30.5862V24.3277C27.7991 24.2556 27.7704 24.1865 27.7195 24.1355C27.4807 23.8967 27.0935 23.8967 26.8547 24.1355C26.8038 24.1865 26.7752 24.2556 26.7752 24.3277V29.3347H25.7512V24.4272Z",
    fill: "#47BE79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1652 24.2148C43.491 24.2148 42.1338 25.572 42.1338 27.2462V34.2533C42.1338 34.3642 42.2237 34.4541 42.3346 34.4541H43.8467C44.0317 34.4541 44.1816 34.6041 44.1816 34.7891V43.5319C44.1816 43.62 44.2166 43.7045 44.2789 43.7667C44.5079 43.9958 44.8793 43.9958 45.1083 43.7667C45.1706 43.7045 45.2056 43.62 45.2056 43.5319V24.2553C45.2056 24.2329 45.1875 24.2148 45.1652 24.2148Z",
    fill: "#47BE79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2514 37.3015C42.363 37.0772 42.3155 36.8141 42.1518 36.6245C41.7994 36.2165 41.0444 36.3043 40.7921 36.7807C39.5894 39.0512 37.2024 40.5979 34.4542 40.5979C31.81 40.5979 29.5002 39.1661 28.2579 37.0354C27.9741 36.5488 27.1347 36.5217 26.8348 36.9986C26.7181 37.184 26.7068 37.4062 26.8118 37.5984C28.2888 40.3008 31.1574 42.1338 34.4542 42.1338C37.8703 42.1338 40.8267 40.1657 42.2514 37.3015Z",
    fill: "#47BE79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2697 28.1215C39.6742 28.4887 40.4264 28.3067 40.6092 27.7919C40.6912 27.5609 40.6427 27.3059 40.4655 27.1365C38.903 25.6438 36.7857 24.7271 34.4542 24.7271C32.3465 24.7271 30.4139 25.4762 28.908 26.7228C28.7484 26.8549 28.6739 27.0551 28.6988 27.2607C28.7688 27.8394 29.5881 28.1358 30.0476 27.7771C31.2632 26.8283 32.7926 26.2629 34.4542 26.2629C36.3079 26.2629 37.9972 26.9667 39.2697 28.1215Z",
    fill: "#47BE79"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9241 33.4304C37.9241 35.3468 36.3706 36.9004 34.4542 36.9004C32.5377 36.9004 30.9842 35.3468 30.9842 33.4304C30.9842 31.514 32.5377 29.9605 34.4542 29.9605C36.3706 29.9605 37.9241 31.514 37.9241 33.4304ZM36.3882 33.4304C36.3882 34.4986 35.5223 35.3645 34.4542 35.3645C33.386 35.3645 32.5201 34.4986 32.5201 33.4304C32.5201 32.3623 33.386 31.4963 34.4542 31.4963C35.5223 31.4963 36.3882 32.3623 36.3882 33.4304Z",
    fill: "#47BE79"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2207_40832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.7537,
    height: 22.7537,
    fill: "white",
    transform: "translate(22.5654 22.5654)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableIcon);
export default __webpack_public_path__ + "static/media/table-icon.aee0d11459b6f2b8ef85802a815f61fe.svg";
export { ForwardRef as ReactComponent };